<div class="container center">
  <div class="center-element mt-2">
    <div class="col-md-12">
      <a routerLink="/">
        <img src="/assets/logo-posso-agendar-borda-azul-desktop.svg" alt="Posso Agendar?" class="login-img hidden-xs" />
        <img src="/assets/logo-posso-agendar-borda-azul.svg" alt="Posso Agendar?" class="login-img visible-xs" />
      </a>
      <h2 class="subtitle">Olá, Digite suas credenciais abaixo e crie sua conta!</h2>
      <form [formGroup]="form" class="example-form">
        <div>
          <mat-card>
            <page-alert message="Usuário registrado com sucesso!" *ngIf="successLogin && submitted"
              alertClass="alert-success"></page-alert>
            <page-alert message="Falha ao registrar usuário!" *ngIf="!successLogin && submitted"
              alertClass="alert-danger"></page-alert>

            <mat-form-field appearance="outline">
              <mat-icon matSuffix>account_circle</mat-icon>
              <mat-label>E-mail</mat-label>
              <input matInput placeholder="Email" formControlName="email" />
              <mat-error *ngIf="form.get('email')?.hasError('required')"> O email é obrigatório. </mat-error>
              <mat-error *ngIf="form.get('email')?.hasError('email')"> Email inválido. </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Senha</mat-label>

              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
              <button type="button" class="icon-button" mat-icon-button matSuffix (click)="hide = !hide"
                [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
                <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>

              <mat-error *ngIf="form.get('password')?.hasError('invalidPassword')">
                A senha deve conter pelo menos 1 número, 1 letra maiúscula, 1 letra minúscula e caracteres especiais.
              </mat-error>

              <mat-error *ngIf="form.get('password')?.hasError('required')"> A senha é obrigatória. </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Confirmar Senha</mat-label>

              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password_confirmation" />
              <button type="button" class="icon-button" mat-icon-button matSuffix (click)="hide = !hide"
                [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
                <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="form.get('password_confirmation')?.hasError('required')"> A confirmação da senha é
                obrigatória.</mat-error>
              <mat-error *ngIf="form.hasError('mismatch')"> As senhas não coincidem. </mat-error>
            </mat-form-field>
            <div class="radio-buttons">
              <mat-label>Tipo de Usuário(*)</mat-label>
              <mat-radio-group formControlName="type">
                <mat-radio-button value="patient">Paciente</mat-radio-button>
                <mat-radio-button value="practitioner">Especialista</mat-radio-button>
                <mat-radio-button value="secretary">Secretária</mat-radio-button>
                <mat-radio-button value="organization">Instituição</mat-radio-button>
              </mat-radio-group>
            </div>

            <button  type="button" mat-button color="primary" (click)="goToUrl('login')" class="btVoltar">Voltar</button>
            <button [disabled]="form.invalid" mat-flat-button color="primary" class="btn-criar"
              (click)="register()">Criar Conta</button>


          </mat-card>

          <div class="social-login">
            <p class="separator">Registrar Com:</p>
            <div class="social-buttons">
              <button mat-stroked-button color="primary" (click)="loginWithGoogle()" class="google">
                <i class="icon-google"></i> Google
              </button>
              <button mat-flat-button color="primary" (click)="loginWithFacebook()" class="facebook">
                <i class="fab fa-facebook"></i> Facebook
              </button>
              <button mat-flat-button color="primary" (click)="loginWithApple()" class="apple">
                <i class="fab fa-apple"></i>Apple
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>